module.exports = __webpack_public_path__ + "img/user-generated-content.db497546.svg";